import { BinaryFilter } from "@cubejs-client/core"
import { TColumnFiltersState } from "../constants/table-visualization-types"

export default function useCubeFiltersFromColumnFilters(
  queryPrefix?: string | null,
  columnFilters?: TColumnFiltersState,
  keyMapping?: Record<string, string>,
): BinaryFilter[] {
  return (columnFilters ?? [])
    .reduce((acc: BinaryFilter[], filterItem) => {
      let filterItemId: string | undefined
      if (keyMapping) {
        filterItemId = keyMapping[filterItem.id]
      } else if (queryPrefix && !filterItem.id.startsWith(queryPrefix)) {
        filterItemId = `${queryPrefix}.${filterItem.id}`
      } else {
        filterItemId = filterItem.id
      }

      if (!filterItemId) return acc

      if (filterItem.variant === "range") {
        const { min, max } = filterItem.value as {
          min?: number
          max?: number
        }
        if (min) {
          acc.push({
            member: filterItemId,
            operator: "gte",
            values: [min.toString()],
          })
        }

        if (max) {
          acc.push({
            member: filterItemId,
            operator: "lte",
            values: [max.toString()],
          })
        }
      } else if (filterItem.variant === "text") {
        const filterValue = filterItem.value
        const isArray = Array.isArray(filterValue)
        const values = isArray ? filterValue : [filterValue]

        acc.push({
          member: filterItemId,
          operator: filterItem.operator as BinaryFilter["operator"],
          values: values.reduce(
            (acc, value) => [...acc, ...value.split(" ")],
            [],
          ),
        })
      } else if (filterItem.variant === "date") {
        const { startDate, endDate } = filterItem.value as {
          startDate?: Date | null | string
          endDate?: Date | null | string
        }

        if (startDate) {
          const startDateObj =
            startDate instanceof Date ? startDate : new Date(startDate)
          acc.push({
            member: filterItemId,
            operator: "gte",
            values: [startDateObj.toISOString().split("T")[0]], // Format as YYYY-MM-DD
          })
        }

        if (endDate) {
          const endDateObj =
            endDate instanceof Date ? endDate : new Date(endDate)
          acc.push({
            member: filterItemId,
            operator: "lte",
            values: [endDateObj.toISOString().split("T")[0]], // Format as YYYY-MM-DD
          })
        }
      } else if (filterItem.variant === "select") {
        const filterValue = filterItem.value as string[]

        if (filterValue && filterValue.length > 0) {
          acc.push({
            member: filterItemId,
            operator: "equals",
            values: filterValue,
          })
        }
      }

      return acc
    }, [])
    .filter((f: BinaryFilter) => !!f)
}
